import { ModuleWithProviders, NgModule } from '@angular/core';
import { AuthModule } from '@freelancer/auth';
import { LocalStorage } from './local-storage.service';

@NgModule({
  imports: [AuthModule],
})
export class LocalStorageModule {
  static initialize(): ModuleWithProviders {
    return {
      ngModule: LocalStorageModule,
      providers: [LocalStorage],
    };
  }
}
